<script lang="ts" setup>
import KnowThat from '@/domains/products/products-multiteatr/know-that/know-that.vue'
import IndividualPath from '@/domains/products/products-multiteatr/individual-path/individual-path.vue'
import YourTomorrowIsToday from '@/domains/products/products-multiteatr/your-tomorrow-is-today/your-tomorrow-is-today.vue'
import TextWithBoxes from '@/components/TextWithBoxes/TextWithBoxes.vue'
import Banner from '@/domains/esg/components/banner/banner.vue'
import Faq from '@/domains/products/products-multiteatr/faq/faq.vue'

const { t, locale } = useI18n()

const multiteatrBoxes = [
  {
    title: t('multiteatr.textWithBoxes.boxes.platinum.title'),
    text: t('multiteatr.textWithBoxes.boxes.platinum.text'),
    image: {
      url: '/images/multiteatr/voucher140x75_MultiTeatr_Platinum.png',
      alternative: 'MultiTeatr Platinum voucher',
    },
  },
  {
    title: t('multiteatr.textWithBoxes.boxes.gold.title'),
    text: t('multiteatr.textWithBoxes.boxes.gold.text'),
    image: {
      url: '/images/multiteatr/voucher140x75_MultiTeatr_Gold.png',
      alternative: 'MultiTeatr Gold voucher',
    },
  },
  {
    title: t('multiteatr.textWithBoxes.boxes.silver.title'),
    text: t('multiteatr.textWithBoxes.boxes.silver.text'),
    image: {
      url: '/images/multiteatr/voucher140x75_MultiTeatr_Silver.png',
      alternative: 'MultiTeatr Silver voucher',
    },
  },
]

useHead({
  title: t('pageTitles.multiteatr.title'),
  meta: [
    {
      name: 'description',
      content: t('pageTitles.multiteatr.meta'),
    },
  ],
  link: [
    {
      hid: 'favicon',
      rel: 'icon',
      type: 'image/x-icon',
      href: '/favicon.ico',
    },
    {
      rel: 'canonical',
      href: t(`pageTitles.multiteatr.canonical.${locale.value}`),
    },
    {
      rel: 'alternate',
      hreflang: 'pl',
      href: t('pageTitles.multiteatr.canonical.pl'),
    },
    {
      rel: 'alternate',
      hreflang: 'en',
      href: t('pageTitles.multiteatr.canonical.en'),
    },
    {
      rel: 'alternate',
      hreflang: 'x-default',
      href: t('pageTitles.multiteatr.canonical.pl'),
    },
  ],
})
</script>

<template>
  <div>
    <Hero
      desktop-image="/images/hero/multilife_desktop.png"
      mobile-image="/images/hero/multilife_mobile.png"
      :header="$t('multiteatr.hero.header')"
      :button="{
        text: $t('multiteatr.hero.buttonText'),
        to: 'https://www.multiteatr.pl/Spektakle',
        target: '_blank'
      }"
      :button2="{
        text: $t('multiteatr.hero.button2Text'),
        to: '#zakres-oferty',
      }"
    />

    <KnowThat />

    <IndividualPath />

    <YourTomorrowIsToday />

    <TextWithBoxes
      id="zakres-oferty"
      layout="default"
      :header="$t('multiteatr.textWithBoxes.header')"
      :text="$t('multiteatr.textWithBoxes.text')"
      :boxes="multiteatrBoxes"
      color="gray"
    />

    <Banner
      id="section2"
      class="section_banner"
      :heading="$t('multiteatr.banner.heading')"
      :text="$t('multiteatr.banner.text')"
      color="white"
      background="blue-400"
      :button="{
        text: $t('multiteatr.banner.button.text'),
        to: $t('multiteatr.banner.button.link'),
        target: '_blank'
      }"
    />

    <Faq />

  </div>
</template>

<style scoped lang="scss">
:deep(.section_banner) {
  min-height: auto;
}

:deep(.banner__text) {
  width:100%;
  font-size: 1.8rem !important;
  line-height: 2.6rem !important;

  @include atM {
    font-size: 3.8rem !important;
    line-height: 4.6rem !important;
  }
}

:deep(.text-with-boxes__content .box__image) {
  height: auto;
  text-align: center;
}

:deep(.text-with-boxes__content .box__image img) {
  width: auto;
  height: auto;
  object-fit: contain;
}
</style>
  
